import axios from 'axios';

export default function request (method, url, history, callback, body) {
    method = method.toUpperCase();
    if (method === 'GET') {
        // fetch的GET不允许有body，参数只能放在url中
        body = undefined;
    } else {
        // body = body && JSON.stringify(body);
    }

    return axios({
        method: method,
        url: url,
        responseType:'json',
        headers: {'token': localStorage.getItem('token')},
        data: body
    }).then((res) => {
        callback(res);
    }).catch(function (error) {
        if(error.response.status === 401 && history){
            history.push('/login');
        }
        console.log(error);
    });
}

export const get = (option) => request('GET', option.url, option.history, option.callback);
export const post = (option) => request('POST', option.url, option.history, option.callback, option.body);
export const put = (option) => request('PUT', option.url, option.history, option.callback, option.body);
export const del = (option) => request('DELETE', option.url, option.history, option.callback, option.body);


// WEBPACK FOOTER //
// ./src/DAL/Request.js